import { MarkNode } from '@lexical/mark';

export class CommentMarkNode extends MarkNode {
  __commentId;

  static getType() {
    return 'comment-mark';
  }

  static clone(node) {
    return new CommentMarkNode(node.__commentId, node.__key);
  }

  constructor(commentId, key) {
    super([], key); 
    this.__commentId = commentId;
  }

  createDOM(config) {
    const dom = super.createDOM(config);

    dom.style.backgroundColor = '#fff3a3';
    dom.style.cursor = 'pointer';

    dom.setAttribute('data-comment-id', String(this.__commentId));

    return dom;
  }

  updateDOM(prevNode, dom) {
    if (prevNode.__commentId !== this.__commentId) {
      dom.setAttribute('data-comment-id', String(this.__commentId));
    }
    return false;
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      type: 'comment-mark',
      commentId: this.__commentId,
      version: 1,
    };
  }

  static importJSON(serialized) {
    if (!serialized.commentId) return null;
    return new CommentMarkNode(serialized.commentId); 
  }
}
